export default "__VITE_ASSET__p33YyASZ__"